// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import echarts from "echarts";
import axios from "axios";
import * as $http from "@/utils/req";
import "./assets/css/base.css";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import storage from "@/utils/Storage";
import { current_season } from "@/utils/common";
import * as $common from "@/utils/common";
import VueLuckyCanvas from "@lucky-canvas/vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import store from "./store/index";
import Vant from "vant";
import "vant/lib/index.css";
// import 'lib-flexible'
import App from "./App";
import router from "./router";

Vue.prototype.$storage = storage;
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
Vue.prototype.$http = $http;
Vue.prototype.$common = $common;
Vue.prototype.current_season = current_season;
Vue.prototype.$echarts = echarts;
Vue.use(ElementUI);
Vue.use(VueLuckyCanvas);
Vue.use(VueAwesomeSwiper);
Vue.use(Vant);

import BaseButton from "./components/BaseButton";
import BaseHeader from "./components/BaseHeader";
import BaseInput from "./components/BaseInput";
import BaseRadio from "./components/BaseRadio";
import BaseTitle from "./components/BaseTitle";
import BaseDivider from "./components/BaseDivider";
import BaseRules from "./components/BaseRules";
import BaseAgree from "./components/BaseAgree";
import BaseScoreHeader from "./components/BaseScoreHeader";
import BaseHeroHeader from "./components/BaseHeroHeader";

import Collapse from "./assets/js/collapse.js";
Vue.component("collapse", Collapse);
Vue.component("base-button", BaseButton);
Vue.component("base-header", BaseHeader);
Vue.component("base-input", BaseInput);
Vue.component("base-radio", BaseRadio);
Vue.component("base-title", BaseTitle);
Vue.component("base-divider", BaseDivider);
Vue.component("base-rules", BaseRules);
Vue.component("base-agree", BaseAgree);
Vue.component("base-score-header", BaseScoreHeader);
Vue.component("base-hero-header", BaseHeroHeader);

if (process.env.NODE_ENV === "production") {
} else if (process.env.NODE_ENV === "test") {
} else {
  let test_token =
    "3678860-e58faae698afe4b880e58faae7be8a-132516-1787252802-215_4-291d0a6ecd6be6885a6952fb4b7b6318";
  storage.setOpenId("otyOgwKtPOKRsUKpX8sXQbOq94qM");
  // storage.setOpenId('otyOgwAAkQKGV1Xt3R0bT68YQ_yU')
  storage.setAuth(test_token);
  storage.setToken(test_token);
}

/* eslint-disable no-new */
let vm = new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});
export default vm;



// WEBPACK FOOTER //
// ./src/main.js